// ** Reducers Imports
import navbar from "./navbar";
import layout from "./layout";
import root from "./slice/root";
import tokens from "./slice/auth";
import users from "./slice/users";
import seats from "./slice/seats";
import auth from "./authentication";
import orders from "./slice/orders";
import addons from "./slice/addons";
import ladatatest from "./slice/test";
import coupons from "./slice/coupons";
import landing from "./slice/landing";
import tickets from "./slice/tickets";
import invoice from "./slice/invoice";
import checkout from "./slice/checkout";
import subs from "./slice/subscriptions";
import createEvents from "./slice/event";
import events from "./slice/events/index";
import attendees from "./slice/attendees";
import exhibitors from "./slice/exhibitors";
import globalConst from "./slice/const/index";
import invitations from "./slice/invitations";
import reservations from "./slice/reservations";
import transactions from "./slice/transactions";
import notifications from "./slice/notifications";
import rolesnpermissions from "./slice/roles&permissions";
import ticketAssignations from "./slice/ticketAssignations";

const rootReducer = {
  auth,
  root,
  subs,
  seats,
  users,
  navbar,
  layout,
  events,
  tokens,
  orders,
  addons,
  tickets,
  coupons,
  invoice,
  landing,
  checkout,
  attendees,
  exhibitors,
  ladatatest,
  globalConst,
  invitations,
  transactions,
  createEvents,
  reservations,
  notifications,
  rolesnpermissions,
  ticketAssignations,
};

export default rootReducer;
